import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom';

// Assets
import fnn_logo from './img/FNNLogoWithWhiteFont-07.png'

// Icons
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faLinkedin,
    faXTwitter,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';

const Footer = () => {

    return (
        <div className='footer-wrapper'>
            <div className='footer-left'>
                <div className='footer-info'>
                    <div className='footer-card'>
                        <h1>PLATFORM</h1>
                        <Link to="/hrl-detector"><p>HRL Detector</p></Link>
                        <Link to="/utility"><p>Utility Solutions</p></Link>
                        <Link to="/agency"><p>Fire Agency Solutions</p></Link>
                        <Link to="/contact"><p>Contact Us</p></Link>
                    </div>

                    <div className='footer-card'>
                        <h1>HEADQUARTERS</h1>
                        <Link to="/contact">
                            <p>747 SW 2nd Avenue <br />
                                Suite 169 <br />
                                Gainesville, FL 32601 <br />
                                United States of America</p>
                        </Link>
                    </div>

                    <div className='footer-card'>
                        <h1>SOCIAL MEDIA</h1>
                        <a
                            href="https://www.youtube.com/@FNN_INC/videos"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>YouTube</p>
                        </a>

                        <a
                            href="https://www.linkedin.com/company/fnninc/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>LinkedIn</p>
                        </a>
                        <a
                            href="https://x.com/_FNNINC"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>X</p>
                        </a>
                    </div>

                    <div className='footer-card'>
                        <h1>DISCOVER</h1>
                        <Link to="/mission"><p>About</p></Link>
                        <Link to="/news"><p>News</p></Link>
                        <Link to="/opportunities"><p>Careers</p></Link>
                        <Link to="/fountainn"><p>FountaiNN</p></Link>
                        <Link to="/login"><p>Portal</p></Link>
                    </div>

                </div>

                <p className='copyright-text'>® {new Date().getFullYear()} FNN™. All rights reserved.</p>

            </div>

            <div className='footer-right'>

                <div className='footer-right-info'>

                    <Link to="/">
                        <img className="fnn-logo" alt="hero background" src={fnn_logo} />
                    </Link>

                    <div className='footer-contact'>
                        <p><BsFillTelephoneFill />+1 (954)-681-1770 </p>
                        <p><MdEmail style={{ width: '1.2rem', height: '1.2rem' }} />team@fireneuralnetwork.com</p>
                    </div>
                </div>


                <div className='footer-social-media'>

                    <a
                        href="https://www.youtube.com/@FNN_INC/videos"
                        className="text-gray-200 hover:text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FontAwesomeIcon icon={faYoutube} size="2x" />
                    </a>

                    <a
                        href="https://www.linkedin.com/company/fnninc/"
                        className="text-gray-200 hover:text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FontAwesomeIcon icon={faLinkedin} size="2x" />
                    </a>

                    <a
                        href="https://x.com/_FNNINC"
                        className="text-gray-200 hover:text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FontAwesomeIcon icon={faXTwitter} size="2x" />
                    </a>

                </div>

            </div>

            <p className='copyright-text2'>® {new Date().getFullYear()} FNN™. All rights reserved.</p>
        </div>
    )
}

export default Footer